import React from 'react';
import localize from '../localize';
import './Tip.css';

const Tip = localize('pages.scores.tips')(({ i18n, name }) => (
  <div className="centered-content">
    <section className={`pro-tip ${name}`}>
      <span className={`icon ${name}`}></span>
      <blockquote>
        <strong>{i18n.t('leader')}</strong>:&nbsp;
        <em dangerouslySetInnerHTML={{ __html: i18n.t(name) }} />
      </blockquote>
    </section>
  </div>
));

export default Tip;



// WEBPACK FOOTER //
// ./src/components/Tip/index.js